define('shoptheme/components/widgets/band',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem"
], function(
	$,
	Component,
	BEM
) {
	return Component.create({
		blocks:			null,

		$init: function() {
			this.blocks = BEM.block("band-widget");
			this.blocks.each(function() {
				var block = BEM.block(this);
				var link = block.getElements("link");
				var href = link.attr("href");

				if (/^#.*/.test(href)) {
					link.click(function(e) {
						e.preventDefault();

						$('html, body').animate({
							scrollTop: $(href).offset().top,
							ease: 'swing'
						}, 200);
					});
				}
			});
		}
	});
});
